import { COMMAND_CENTER_ROOT } from './commandCenterRoutes'
import { useNavigate } from 'react-router-dom'
import { CommunicationsHome, useChannels, useDms, createChannel, COMMS_ROOT, TEAM_ROOT, CONFERENCE_CALLS_ROOT } from './comms'

/**
 * V2 Communications home — route wrapper.
 *   /square/command-center/communications        (mode='channels')
 *   /square/command-center/communications/dms    (mode='dms')
 *
 * Owns the live channel/DM hooks; the surface is presentational + SSR-safe.
 * No fabricated channels or DMs.
 */
export default function SquareCodeCommunicationsRoute({ mode = 'channels' as 'channels' | 'dms' }: { mode?: 'channels' | 'dms' }) {
  const navigate = useNavigate()
  const channels = useChannels()
  const dms = useDms()
  return (
    <CommunicationsHome
      mode={mode}
      channels={channels.items}
      dms={dms.items}
      loading={channels.loading || dms.loading}
      error={channels.error || dms.error}
      authRequired={channels.authRequired || dms.authRequired}
      onOpenChannel={(id) => navigate(`${COMMS_ROOT}/channels/${id}`)}
      onOpenDm={(id) => navigate(`${COMMS_ROOT}/dms/${id}`)}
      onCreateChannel={async (name) => { await createChannel({ name }); channels.reload() }}
      onOpenTeam={() => navigate(TEAM_ROOT)}
      onOpenConferenceCalls={() => navigate(CONFERENCE_CALLS_ROOT)}
      onOpenTasks={() => navigate(TEAM_ROOT)}
      onHome={() => navigate(COMMAND_CENTER_ROOT)}
      onBackCommandCenter={() => navigate(COMMAND_CENTER_ROOT)}
      onNavTop={(to) => navigate(to)}
    />
  )
}
